const ActiveNavigation = {
	menuItems: null,
	allMenuItems: null,
	sections: null,
	currentActiveSection: null,
	isFirstRun: true,
	
	init() {
		// Get all menu items with anchor links (both desktop and mobile)
		this.menuItems = document.querySelectorAll('#top-menu a[href*="#"], #mobile_menu a[href*="#"]');
		
		// Get ALL menu items for removing active class (including home links)
		this.allMenuItems = document.querySelectorAll('#top-menu a, #mobile_menu a');
		
		if (!this.menuItems.length) {
			return;
		}

		// Get all sections that correspond to menu anchor links
		this.sections = this.getSections();
		
		if (!this.sections.length) {
			return;
		}

		// Bind the context of `this` for the event handler
		this.handleScroll = this.handleScroll.bind(this);

		// Clear all active classes first to ensure clean state
		this.clearAllActiveClasses();

		// Run on load in case the page is already scrolled to a section
		this.handleScroll();

		// Listen for scroll events
		window.addEventListener("scroll", this.handleScroll, { passive: true });
		
		// Listen for hash changes (when clicking anchor links)
		window.addEventListener("hashchange", this.handleScroll, { passive: true });
	},

	getSections() {
		const sections = [];
		
		this.menuItems.forEach(item => {
			const href = item.getAttribute('href');
			const hash = href.split('#')[1];
			
			if (hash) {
				const section = document.getElementById(hash);
				if (section) {
					sections.push({
						id: hash,
						element: section,
						menuItems: document.querySelectorAll(`a[href$="#${hash}"]`)
					});
				}
			}
		});
		
		return sections;
	},

	clearAllActiveClasses() {
		// Remove active class from ALL menu items
		this.allMenuItems.forEach(item => {
			item.parentElement.classList.remove('active');
		});
	},

	handleScroll() {
		const scrollPosition = window.pageYOffset;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		
		// ALWAYS clear all active classes first - no exceptions
		this.clearAllActiveClasses();
		
		let newActiveSection = null;
		let closestSection = null;
		let smallestDistance = Infinity;

		// Find the section that's closest to the top of the viewport
		this.sections.forEach(section => {
			const rect = section.element.getBoundingClientRect();
			const elementTop = rect.top + scrollPosition;
			
			// Calculate distance from the top of the viewport to the section
			const distanceFromTop = Math.abs(elementTop - scrollPosition);
			
			// If this section has passed the top of the viewport (elementTop <= scrollPosition + offset)
			// and is closer than the previous closest, make it the candidate
			const offset = windowHeight * 0.3; // 30% from top of viewport as trigger point
			
			if (elementTop <= scrollPosition + offset) {
				if (distanceFromTop < smallestDistance || elementTop <= scrollPosition + offset) {
					closestSection = section;
					smallestDistance = distanceFromTop;
				}
			}
		});

		// Use the closest section that has passed the trigger point
		newActiveSection = closestSection;

		// Special case: if we're near the bottom of the page, activate the last section
		if (scrollPosition + windowHeight >= documentHeight - 100) {
			newActiveSection = this.sections[this.sections.length - 1];
		}

		// Special case: if we're at the very top, activate home
		if (scrollPosition < 50) {
			newActiveSection = 'home';
		}

		// Now add active class to the determined section
		if (newActiveSection === 'home') {
			// Find home links more accurately
			const homeItems = document.querySelectorAll('#top-menu a[href="/"], #top-menu a[href="' + window.location.origin + '/"], #top-menu a[href="' + window.location.origin + window.location.pathname + '"], #mobile_menu a[href="/"], #mobile_menu a[href="' + window.location.origin + '/"], #mobile_menu a[href="' + window.location.origin + window.location.pathname + '"]');
			homeItems.forEach(item => {
				item.parentElement.classList.add('active');
			});
		} else if (newActiveSection) {
			newActiveSection.menuItems.forEach(item => {
				item.parentElement.classList.add('active');
			});
		}

		// Update the current active section
		this.currentActiveSection = newActiveSection;
		this.isFirstRun = false;
	}
};

export default ActiveNavigation;